'use client';

import useOneTapSignin from '@hooks/useOneTapSignin';
import { DEFAULT_REDIRECT_URL } from '@lib/auth/redirectUrl';
import { usePathname, useSearchParams } from 'next/navigation';
import React from 'react';

const OneTapComponent = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  // Get the redirect URL from query parameters or use default
  const redirectUrl = React.useMemo(() => {
    const redirectQuery = searchParams?.get('redirect');
    if (typeof redirectQuery === 'string') {
      return redirectQuery;
    }
    return DEFAULT_REDIRECT_URL;
  }, [searchParams]);

  useOneTapSignin({
    redirect: true,
    parentContainerId: 'oneTap',
    callbackUrl: `/login/success?redirect=${encodeURIComponent(redirectUrl)}`
  });

  // Don't render the component if we're on an onboarding path
  if (pathname?.startsWith('/onboarding')) {
    return null;
  }

  return <div id="oneTap" className="fixed top-2 right-2 z-[99999]" />;
};

export default OneTapComponent;
